import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import PortalHub from '../../pages/Portal/PortalHub';
import { getReachableSpaces } from '../Portal/portalSpaces';

/* Entry point for /portal (the multi-space hub). Kept role-tolerant so a stray
   /portal hit always lands somewhere sensible (it replaces the old
   PortalRedirect behaviour for this exact path):
   - Unauthenticated → login.
   - Customer → their own dashboard (customers never had spaces).
   - Owner (reaches >1 space) → the four-card hub.
   - Single-space user (employee, e.g. Annelise → Work) → redirected straight
     into their dashboard. No hub, no one-tile picker. */
function PortalSpaceEntry() {
	const { currentUser, userRole, userProfile } = useAuth();

	if (!currentUser) {
		return <Navigate to='/portal/login' replace />;
	}
	if (userRole !== 'employee' && userRole !== 'admin') {
		return <Navigate to='/portal/customer' replace />;
	}

	const spaces = getReachableSpaces(userProfile, currentUser?.email);
	if (spaces.length <= 1) {
		return <Navigate to={spaces[0]?.route || '/portal/work'} replace />;
	}

	return <PortalHub />;
}

export default PortalSpaceEntry;
